import { Checkbox, Spin, Table } from "antd";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import { loggedInUser } from "core/redux/slice/authSlice";
import {
  addDays,
  endOfMonth,
  format,
  getDaysInMonth,
  startOfMonth,
  subMonths,
  addMonths,
  startOfWeek,
  endOfWeek,
  addWeeks,
  startOfDay,
  subWeeks,
} from "date-fns";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Modal, message } from "antd";
import { useGetAllShiftPoliciesQuery } from "AppQuries/shift/policy/shift-policy";
import AssignShift from "Components/Filter/AssignShift";
import { useForm, FormProvider } from "react-hook-form";
import { OverlayTrigger, Popover } from "react-bootstrap";
import {
  useGetShiftSheduleQuery,
  useShiftScheduleCreationMutation,
} from "AppQuries/shift/schedule/scheduler";
import { all_routes } from "Router/all_routes";
import Error404 from "MainPages/ErrorPages/error404";
import moment from "moment";
import { Edit } from "react-feather";
import { toast } from "core/Operations/toast";
import { Link } from "react-router-dom";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
const EmployeeShiftMapping = () => {
  const userData = useSelector(loggedInUser);
  const [isMount, setIsMount] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [openPopover, setOpenPopover] = useState(null);

  const handlePopoverToggle = (popoverId) => {
    setOpenPopover((prevPopover) =>
      prevPopover === popoverId ? null : popoverId
    );
  };

  const handlePopoverClose = () => {
    setOpenPopover(null);
  };

  const [scheduleDate, setScheduleDate] = useState(() => {
    const today = new Date();
    return {
      currentMonth: today,
      fromDate: format(startOfWeek(today), "yyyy-MM-dd"),
      toDate: format(endOfWeek(today), "yyyy-MM-dd"),
      daysInMonth: 7, //getDaysInMonth(today),
    };
  });

  const {
    mutate: shiftAssign,
    isError,
    error,
  } = useShiftScheduleCreationMutation();

  const methods = useForm({
    defaultValues: {
      companyCode: userData?.companyCode,
      locationCode: userData?.locationCode,
      createUser: userData?.userName,
      approvedBy: userData?.userName,
      selectedEmployees: [],
      shiftID: "",
      scheduleFromDate:
        scheduleDate?.fromDate || format(startOfWeek(new Date()), "yyyy-MM-dd"),
      scheduleToDate:
        scheduleDate?.toDate || format(endOfWeek(new Date()), "yyyy-MM-dd"),
    },
  });

  const { setValue, getValues, watch } = methods;
  const { data: employees } = useGetEmployeeQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
  });

  const { data: shiftPolicies } = useGetAllShiftPoliciesQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    isTrue: true,
  });

  const {
    data: scheduleData,
    isPending,
    refetch: getScheduleData,
  } = useGetShiftSheduleQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    fromDate: scheduleDate?.fromDate || format(new Date(), "yyyy-MM-dd"),
    toDate: scheduleDate?.toDate || format(new Date(), "yyyy-MM-dd"),
    groupCode: "",
    shiftCode: "",
    employeeCode: 0,
  });

  const employeesList = Array.isArray(employees)
    ? employees
        .filter((d) => d.isActive === true)
        .map((d, _id) => ({
          key: _id,
          id: _id,
          ...d,
        }))
    : [];

  const updateWeek = (direction) => {
    const updatedMonth =
      direction === "next"
        ? addWeeks(new Date(scheduleDate.fromDate), 1)
        : subWeeks(new Date(scheduleDate.fromDate), 1);
    setScheduleDate({
      currentMonth: updatedMonth,
      fromDate: format(startOfWeek(updatedMonth), "yyyy-MM-dd"),
      toDate: format(endOfWeek(updatedMonth), "yyyy-MM-dd"),
      daysInMonth: 7, //getDaysInMonth(updatedMonth),
    });
  };

  const assignShiftHandler = ({
    shiftPolicyID,
    date,
    employeeCode,
    groupCode,
  }) => {
    const payload = [
      {
        companyCode: userData?.companyCode,
        locationCode: userData?.locationCode,
        employeeCode: employeeCode.toString(),
        groupCode: groupCode,
        shiftID: shiftPolicyID,
        scheduleFromDate: `${format(new Date(date), "yyyy-MM-dd")}T${format(
          new Date(),
          "HH:mm:ss.SSS"
        )}Z`,
        scheduleToDate: `${format(new Date(date), "yyyy-MM-dd")}T${format(
          new Date(),
          "HH:mm:ss.SSS"
        )}Z`,
        createUser: userData?.userName,
        remarks: "",
        approvedBy: userData?.userName,
        isActive: true,
      },
    ];

    saveShift(payload);
  };

  const [count, setCount] = useState(0);

  const saveShift = (payload) => {
    console.log("Shift Assign Payload:", count);
    setCount((prev) => prev + 1);
    shiftAssign(payload, {
      onSuccess: (data) => {
        if (data?.[0]?.response === true) {
          toast.success("Shift Assigned Successfully.");
          getScheduleData();
          setSelectedEmployees([]);
        } else {
          toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        message.error(error.message || "Something went wrong.");
      },
    });
  };

  const popoverForShiftAssign = (data) => (
    <Popover id={data?.customClass} className={data?.customClass}>
      {shiftPolicies?.map((shift, _id) => (
        <Popover.Header as="h3" key={_id}>
          <button
            className="btn btn-default"
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              assignShiftHandler({
                shiftPolicyID: shift.shiftPolicyID,
                ...data,
              });
              handlePopoverToggle();
            }}
          >
            {`${shift?.shiftName}-(${shift?.locationCode})`}
          </button>
        </Popover.Header>
      ))}
    </Popover>
  );

  const handleSelect = (record, selected) => {
    let newSelection = selected
      ? [...selectedEmployees, record.employeeCode]
      : selectedEmployees.filter((code) => code !== record.employeeCode);

    setValue("selectedEmployees", newSelection);
    setSelectedEmployees(newSelection);
  };

  const toggleSelectAll = () => {
    let newSelection =
      selectedEmployees.length === employeesList.length
        ? []
        : employeesList.map((r) => r.employeeCode);

    setValue("selectedEmployees", newSelection);

    setSelectedEmployees((prev) => {
      return prev.length === employeesList.length
        ? []
        : employeesList.map((r) => r.employeeCode);
    });
  };

  const headerCheckbox = (
    <Checkbox
      checked={selectedEmployees.length === employeesList.length}
      indeterminate={
        selectedEmployees.length > 0 &&
        selectedEmployees.length < employeesList.length
      }
      onChange={toggleSelectAll}
    />
  );

  const rowSelection = {
    selectedRowKeys: selectedEmployees,
    type: "checkbox",
    fixed: true,
    onSelect: handleSelect,
    columnTitle: headerCheckbox,
  };

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueId",
      key: "uniqueId",
    },
    {
      title: "Emp Name",
      dataIndex: "fullName",
      sorter: (a, b) => a.fullName.length - b.fullName.length,
      fixed: "left",
      width: "200",
      filters: Array.from(
        new Set(
          employees
            ?.filter((d) => d.isActive === true)
            .map((d) => d?.fullName)
            .filter(Boolean)
        )
      ).map((name) => ({ text: name, value: name })),
      onFilter: (value, record) => record.fullName?.startsWith(value),
      render: (text, record) => (
        <Link
          to={`${all_routes.employee}${all_routes.employee_view}/${record.employeeCode}`}
        >
          {text}
        </Link>
      ),
    },
    {
      title: "Group",
      dataIndex: "groupName",
      sorter: (a, b) => a.groupName.length - b.groupName.length,
      filters: Array.from(
        new Set(employees?.map((d) => d?.groupName).filter(Boolean))
      ).map((name) => ({ text: name, value: name })),
      onFilter: (value, record) => record.groupName?.startsWith(value),
      render: (text, record) =>
        record.groupCode ? (
          <Link
            to={`${all_routes.employee}?groupCode=${record.groupCode}`}
            className="btn btn-link"
          >
            <span className="badge bg-primary">{text || "N/A"}</span>
          </Link>
        ) : (
          <span className="badge bg-primary">{record.groupName}</span>
        ),
    },

    ...Array.from({ length: scheduleDate.daysInMonth }, (_, index) => {
      const currentDate = addDays(startOfWeek(scheduleDate.fromDate), index);

      return {
        title: (
          <div style={{ width: "200px" }}>
            {format(currentDate, "dd-MM-yyyy")} (
            <span>{format(currentDate, "EEE")}</span>)
          </div>
        ),
        dataIndex: `day_${index + 1}`,
        align: "center",

        render: (_, record) => {
          const schedule = scheduleData?.find(
            (s) =>
              Number(s.employeeCode) === record.employeeCode &&
              format(new Date(s.scheduleDate), "yyyy-MM-dd") ===
                format(currentDate, "yyyy-MM-dd")
          );
          const popoverId = `${record.employeeCode}_${format(
            currentDate,
            "yyyy-MM-dd"
          )}`;
          return (
            <>
              {schedule ? (
                <div className="assigned-shift">
                  <Can
                    accessModule={accessCodes.shift_management}
                    accessCode={accessCodes.shift_employee_mapping}
                    accessType="haveEdit"
                  >
                    <OverlayTrigger
                      trigger="focus"
                      placement="right"
                      overlay={popoverForShiftAssign({
                        customClass: "popover-dismiss-center",
                        date: currentDate,
                        employeeCode: record.employeeCode,
                        groupCode: record.groups,
                      })}
                      show={openPopover === popoverId}
                      onToggle={() => handlePopoverToggle(popoverId)}
                    >
                      <button type="button" className="btn btn-secondary">
                        {schedule?.shiftName}
                        <br />
                        {moment(schedule.shiftInTimeStr, ["HH:mm"]).format(
                          "hh:mm A"
                        ) || "N/A"}
                        -
                        {moment(schedule.shiftOutTimeStr, ["HH:mm"]).format(
                          "hh:mm A"
                        ) || "N/A"}
                        {/* <Edit /> */}
                      </button>
                    </OverlayTrigger>
                  </Can>
                </div>
              ) : startOfDay(new Date(scheduleDate.toDate)) >=
                startOfDay(new Date()) ? (
                <div className="non-assigned-shift">
                  <Can
                    accessModule={accessCodes.shift_management}
                    accessCode={accessCodes.shift_employee_mapping}
                    accessType="haveAdd"
                  >
                    <OverlayTrigger
                      trigger="focus"
                      placement="right"
                      overlay={popoverForShiftAssign({
                        customClass: "popover-dismiss-center",
                        date: currentDate,
                        employeeCode: record.employeeCode,
                        groupCode: record.groups,
                      })}
                      show={openPopover === popoverId}
                      onToggle={() => handlePopoverToggle(popoverId)}
                    >
                      <button
                        type="button"
                        className="btn btn-square btn-outline-secondary"
                      >
                        <i className="fas fa-plus" />
                        Add
                      </button>
                    </OverlayTrigger>
                  </Can>
                </div>
              ) : (
                <div className="non-assigned-shift">Date Expired</div>
              )}
            </>
          );
        },
      };
    }),
  ];

  useEffect(() => {
    if (isMount) {
      getScheduleData();
    }
    setIsMount(true);
  }, [scheduleDate]);

  if (isError) return <Error404 error={error} />;

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          {selectedEmployees.length === 0 && (
            <>
              <div className="page-title">
                <h4>Employee Shift Mapping</h4>
              </div>
              <div
                className="page-controls"
                style={{ display: "flex", alignItems: "center", gap: "2px" }}
              >
                <button
                  className="btn btn-icon btn-primary"
                  onClick={() => updateWeek("previous")}
                >
                  &lt;
                </button>
                <span
                  style={{
                    padding: "8px",
                    border: "1px solid #ddd",
                    maxWidth: "200px",
                  }}
                >
                  {format(new Date(scheduleDate.fromDate), "dd-MMM")} -
                  {format(new Date(scheduleDate.toDate), "dd-MMM")}
                </span>
                <button
                  className="btn btn-icon btn-primary"
                  onClick={() => updateWeek("next")}
                >
                  &gt;
                </button>
              </div>
            </>
          )}

          {selectedEmployees.length > 0 && (
            <button
              type="button"
              className="btn btn-primary"
              // disabled={selectedEmployees.length <= 0}
              onClick={() => setShowFilter(!showFilter)}
            >
              Assign Shift
            </button>
          )}
        </div>

        <div className="row">
          <div className="card border-0">
            <div className="table-responsive">
              <Spin spinning={isPending}>
                <Table
                  rowSelection={rowSelection}
                  columns={columns}
                  dataSource={employeesList}
                  rowKey={(record) => record.employeeCode}
                  pagination={true}
                />
              </Spin>
            </div>
          </div>
        </div>
        <FormProvider {...methods}>
          <AssignShift
            show={showFilter}
            setShow={setShowFilter}
            employees={employeesList}
            shiftPolicies={shiftPolicies || []}
            saveShift={saveShift}
          />
        </FormProvider>
      </div>
    </div>
  );
};

export default EmployeeShiftMapping;
